import { useNavigate } from 'react-router-dom';
import { ButtonBack } from '../../../../components/ButtonBack';
import { Card } from '../../../../components/Card';
import { TextReveal } from '../../../../components/TextReveal';
import { KNOWLEDGE_TRAIL, QUIZ } from '../../../../constants/Routes';
import { SupportingMaterials } from '../../../../components/SupportingMaterials';
import { useAuth } from '../../../../hooks/useAuth';
import { getYouTubeEmbed } from '../../../../utils/getYouTubeEmbed';
import { IKnowledgeTrail, IKnowledgeTrailContent } from '../../types';

interface KnowledgeTrailContentViewProps {
  content: IKnowledgeTrailContent;
  contentIndex: number;
  courseBookUrl?: string;
  trail: IKnowledgeTrail;
}

export function KnowledgeTrailContentView({
  content,
  contentIndex,
  trail,
}: KnowledgeTrailContentViewProps) {
  const { client } = useAuth();
  const navigate = useNavigate();
  const primaryColor = client?.primaryColor || '#333';

  const embedUrl = content.videoUrl
    ? getYouTubeEmbed(content.videoUrl, {
        controls: true,
        autoplay: false,
        mute: false,
        loop: false,
      })
    : null;

  const isDirectVideo = !embedUrl && !!content.videoUrl;

  return (
    <div className="container">
      <div className="row">
        <div className="my-3">
          <ButtonBack
            title={'Trilha'}
            to={`${KNOWLEDGE_TRAIL}/${trail.id}`}
            state={{ trail }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-xl-8">
          <Card>
            {embedUrl && (
              <div className="ratio ratio-16x9">
                <iframe
                  src={embedUrl}
                  className="rounded-3"
                  title={content.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}
            {isDirectVideo && (
              <div className="ratio ratio-16x9">
                <video
                  src={content.videoUrl}
                  className="rounded-3"
                  controls
                  autoPlay
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </div>
            )}

            <TextReveal
              title={content.title}
              subtitle="Conteúdo da Trilha"
              content={content.description}
            />

            <SupportingMaterials
              materials={content.supportingMaterials}
              primaryColor={primaryColor}
            />

            {content.quiz &&
              content.playerPerformance.isPlayerAllowedToAnswerQuiz && (
                <div className="mt-4">
                  <div className="d-grid">
                    <button
                      style={{
                        padding: '10px 16px',
                        borderRadius: '8px',
                        border: 'none',
                        backgroundColor: primaryColor,
                        color: '#fff',
                        fontSize: '14px',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        navigate(`${QUIZ}/${content.quiz.id}`, {
                          state: {
                            returnPath: `${KNOWLEDGE_TRAIL}/${trail.id}/content/${contentIndex}`,
                            returnState: { trail },
                          },
                        })
                      }
                    >
                      Responder quiz agora
                    </button>
                  </div>
                </div>
              )}
          </Card>
        </div>
      </div>
    </div>
  );
}
